import React, { Component } from "react";
import { connect } from "react-redux";
import { Form, Button } from "semantic-ui-react";
import _ from "lodash";
import {
  getSecQuestions,
  isTokenValid,
  expireSession,
} from "../../actions/auth";
import InlineError from "../messages/InlineError";
import {
  ERR_MSG_WRONG_SECURITY_QUESTION_ANSWER,
  ERR_ANSWERS_NOT_FILLED,
} from "../../ErrorMessages";

class SecurityQuestionsForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        qaList: [],
      },
      errors: { answer: [] },
    };
    if (this.props.isTokenValid())
      this.props
        .getSecQuestions()
        .then((res) => {
          if (res.data.Message === "success") {
            const data = this.state.data;
            const errors = this.state.errors;
            if (res.data.QuestionList && res.data.QuestionList.length > 0) {
              _.map(res.data.QuestionList, (qa) => {
                data.qaList.push({ question: qa.Question, answer: "" });
                errors.answer.push("");
              });
            }
            this.setState({ data, errors });
          }
        })
        .catch((err) => {
          console.log("Unable to fetch security questions", err);
        });
  }

  componentDidMount() {
    if (!this.props.isTokenValid()) this.props.expireSession();
  }

  onChange = (e) => {
    const { data } = this.state;
    data.qaList[Number(e.target.name.split("_")[1])].answer = e.target.value;
    this.setState({
      data,
    });
  };

  onSubmit = () => {
    const errorFound = this.validate(this.state.data);
    if (!errorFound) {
      this.props.submit(this.state.data).catch((err) => {
        if (err.response) this.setState({ errors: err.response.data.errors });
      });
    }
  };

  validate = (data) => {
    let errorFound = false;
    const { errors } = this.state;
    _.map(data.qaList, (qa, index) => {
      if (qa.answer.trim() === "") {
        errors.answer[index] = ERR_ANSWERS_NOT_FILLED;
        if (!errorFound) {
          const answerElement = document.getElementById(`answer_${index}`);
          if (answerElement) {
            answerElement.focus();
          }
        }
        errorFound = true;
      } else {
        errors.answer[index] = "";
      }
    });
    this.setState({ errors });
    return errorFound;
  };

  render() {
    const { data, errors } = this.state;
    const qaFields = [];
    const qaErrors = [];
    if (this.props.respData !== undefined) {
      _.map(this.props.respData, (qaErr) => {
        qaErrors.push(qaErr.Question);
      });
    }
    _.map(data.qaList, (qa, index) => {
      if (qaErrors.length > 0 && qaErrors.indexOf(qa.question) > -1) {
        errors.answer[index] = ERR_MSG_WRONG_SECURITY_QUESTION_ANSWER;
      }
      qaFields.push(
        <Form.Field
          error={errors && errors.answer && errors.answer[index] !== ""}
          key={`Qa_${index}`}
        >
          <label htmlFor="question">{qa.question}</label>
          <input
            type="text"
            id={`answer_${index}`}
            name={`answer_${index}`}
            placeholder="answer"
            onChange={this.onChange}
          />
          {errors && errors.answer && errors.answer[index] !== "" && (
            <InlineError text={errors.answer[index]} />
          )}
        </Form.Field>
      );
    });
    return (
      <Form onSubmit={this.onSubmit} loading={this.props.loading}>
        {qaFields}
        {qaFields.length > 0 && <Button primary>submit</Button>}
      </Form>
    );
  }
}

export default connect(null, {
  getSecQuestions,
  isTokenValid,
  expireSession,
})(SecurityQuestionsForm);



// WEBPACK FOOTER //
// ./src/components/forms/SecurityQuestionsForm.js